import React, { useEffect, useState, useCallback } from 'react';
import BlogsList from './BlogsList';
import PartnersList from './PartnersList';
import RestaurantReview from './RestaurantReview';
import UsersList from './UsersList';
import { host } from '../script/variables';
import '../style/AdminDashboard.css';
import InteractiveMap from './InteractiveMap';
import DocumentsList from './DocumentsList';
import PlanManagement from './PlanManagement';

// ─── Icons (inline SVG — no extra dependency) ──────────────────────────────────
const Icon = ({ name, size = 20 }) => {
  const icons = {
    dashboard: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/>
      </svg>
    ),
    blog: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
        <polyline points="10 9 9 9 8 9"/>
      </svg>
    ),
    partners: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    restaurant: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/>
        <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/>
      </svg>
    ),
    users: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
    ),
    check: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    ),
    warning: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
    ),
    trending: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
        <polyline points="17 6 23 6 23 12"/>
      </svg>
    ),
    refresh: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="23 4 23 10 17 10"/>
        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
      </svg>
    ),
    menu: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
    ),
    close: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    ),
    maps:(
         <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s-6-5.33-6-10a6 6 0 1 1 12 0c0 4.67-6 10-6 10z"/>
    <circle cx="12" cy="11" r="2.5"/>
  </svg>
    ),
    plans: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2"/>
        <line x1="2" y1="10" x2="22" y2="10"/><line x1="6" y1="15" x2="10" y2="15"/>
      </svg>
    )
  };
  return icons[name] || null;
};

// ─── Stat Card ─────────────────────────────────────────────────────────────────
const StatCard = ({ label, value, sub, accent, icon, delay = 0 }) => (
  <div className="ad-stat-card" style={{ animationDelay: `${delay}ms` }}>
    <div className="ad-stat-icon" style={{ '--accent': accent }}>
      <Icon name={icon} size={18} />
    </div>
    <div className="ad-stat-body">
      <div className="ad-stat-value">{value ?? <span className="ad-skeleton" />}</div>
      <div className="ad-stat-label">{label}</div>
      {sub && <div className="ad-stat-sub">{sub}</div>}
    </div>
  </div>
);

// ─── Overview / Dashboard Panel ────────────────────────────────────────────────
const OverviewPanel = ({ data, onRefresh, loading }) => {
  const stats = [
    {
      label: 'Total Restaurants', value: data?.totalRestaurants,
      sub: `${data?.verifiedRestaurants ?? '—'} verified · ${data?.unverifiedRestaurants ?? '—'} pending`,
      accent: '#f59e0b', icon: 'restaurant', delay: 0,
    },
    {
      label: 'Total Users', value: data?.totalUsers,
      sub: 'Registered accounts', accent: '#06b6d4', icon: 'users', delay: 60,
    },
    {
      label: 'Partners', value: data?.totalPartners,
      sub: 'Active partnerships', accent: '#a78bfa', icon: 'partners', delay: 120,
    },
    {
      label: 'Approved Blogs', value: data?.approvedBlogs,
      sub: `${data?.unapprovedBlogs ?? '—'} pending · ${data?.draftedBlogs ?? '—'} drafts`,
      accent: '#34d399', icon: 'blog', delay: 180,
    },
  ];

  return (
    <div className="ad-panel ad-panel--overview">
      <div className="ad-panel-header">
        <div>
          <h2 className="ad-panel-title">Overview</h2>
          <p className="ad-panel-sub">Live snapshot of your platform</p>
        </div>
        <button
          className={`ad-refresh-btn ${loading ? 'ad-refresh-btn--spinning' : ''}`}
          onClick={onRefresh}
          title="Refresh data"
        >
          <Icon name="refresh" size={16} />
          <span>Refresh</span>
        </button>
      </div>

      <div className="ad-stats-grid">
        {stats.map((s) => <StatCard key={s.label} {...s} />)}
      </div>

      {/* Quick status summary */}
      <div className="ad-status-row">
        <div className="ad-status-chip ad-status-chip--ok">
          <Icon name="check" size={13} />
          <span>{data?.verifiedRestaurants ?? '—'} Verified Restaurants</span>
        </div>
        <div className="ad-status-chip ad-status-chip--warn">
          <Icon name="warning" size={13} />
          <span>{data?.unverifiedRestaurants ?? '—'} Awaiting Verification</span>
        </div>
        <div className="ad-status-chip ad-status-chip--info">
          <Icon name="trending" size={13} />
          <span>{data?.unapprovedBlogs ?? '—'} Blogs Need Review</span>
        </div>
      </div>
    </div>
  );
};

// ─── Nav items config ──────────────────────────────────────────────────────────
const NAV_ITEMS = [
  { id: 'overview',    label: 'Overview',    icon: 'dashboard'   },
  { id: 'blogs',       label: 'Blogs',       icon: 'blog'        },
  { id: 'partners',    label: 'Partners',    icon: 'partners'    },
  { id: 'restaurants', label: 'Restaurants', icon: 'restaurant'  },
  { id: 'users',       label: 'Users',       icon: 'users'       },
  { id: 'maps',        label: 'Global Presence',        icon: 'maps'        },
  { id: 'docs',        label: 'Documents',        icon: 'blog'        },
  { id: 'plans',       label: 'Plans',       icon: 'plans'       },
];

// ─── Main Component ────────────────────────────────────────────────────────────
const AdminDashboard = ({ user, onLogout }) => {
  const [dashboardData, setDashboardData] = useState(null);
  const [activeSection, setActiveSection] = useState('overview');
  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const getDashboardData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${host}/admin/getDashboarddata`, {
        method: 'GET',
        credentials: 'include',
      });
      if (res.ok) {
        const data = await res.json();
        setDashboardData(data);
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getDashboardData();
  }, [getDashboardData]);

  // Close sidebar when section changes on mobile
  const handleNavClick = (id) => {
    setActiveSection(id);
    setSidebarOpen(false);
  };

  const renderSection = () => {
    switch (activeSection) {
      case 'overview':
        return <OverviewPanel data={dashboardData} onRefresh={getDashboardData} loading={loading} />;
      case 'blogs':
        return (
          <div className="ad-panel">
            <div className="ad-panel-header">
              <div>
                <h2 className="ad-panel-title">Blogs</h2>
                <p className="ad-panel-sub">Manage, approve and review blog content</p>
              </div>
            </div>
            <BlogsList />
          </div>
        );
      case 'partners':
        return (
          <div className="ad-panel">
            <div className="ad-panel-header">
              <div>
                <h2 className="ad-panel-title">Partners</h2>
                <p className="ad-panel-sub">Review and manage restaurant partners</p>
              </div>
            </div>
            <PartnersList />
          </div>
        );
      case 'restaurants':
        return (
          <div className="ad-panel">
            <div className="ad-panel-header">
              <div>
                <h2 className="ad-panel-title">Restaurants</h2>
                <p className="ad-panel-sub">Review and verify restaurant listings</p>
              </div>
            </div>
            <RestaurantReview />
          </div>
        );
      case 'users':
        return (
          <div className="ad-panel">
            <div className="ad-panel-header">
              <div>
                <h2 className="ad-panel-title">Users</h2>
                <p className="ad-panel-sub">Browse and manage user accounts</p>
              </div>
            </div>
            <UsersList />
          </div>
        );
     case 'maps':
        return (
          <div className="ad-panel">
            <div className="ad-panel-header">
              <div>
                <h2 className="ad-panel-title">Global View</h2>
                <p className="ad-panel-sub">Global Presence</p>
              </div>
            </div>
            <InteractiveMap />
          </div>
        );

    case 'docs':
      return (
        <div className="ad-panel">
            <div className="ad-panel-header">
              <div>
                <h2 className="ad-panel-title">Documents</h2>
                <p className="ad-panel-sub">Documents</p>
              </div>
            </div>
            <DocumentsList />
          </div>
      )
    case 'plans':
      return (
        <div className="ad-panel">
            <div className="ad-panel-header">
              <div>
                <h2 className="ad-panel-title">Plans & Subscriptions</h2>
                <p className="ad-panel-sub">Manage subscription plans, versions, entitlements and owner subscriptions</p>
              </div>
            </div>
            <PlanManagement />
          </div>
      )
      default:
        return null;
    }
  };

  const activeNav = NAV_ITEMS.find(n => n.id === activeSection);

  return (
    <div className="ad-root">

      {/* ── Sidebar ── */}
      <aside className={`ad-sidebar ${sidebarOpen ? 'ad-sidebar--open' : ''}`}>
        <div className="ad-sidebar-brand">
          <div className="ad-brand-logo">R</div>
          <div className="ad-brand-text">
            <span className="ad-brand-name">RestroPilots</span>
            <span className="ad-brand-role">Admin Console</span>
          </div>
        </div>

        <nav className="ad-nav">
          <div className="ad-nav-label">Navigation</div>
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              className={`ad-nav-item ${activeSection === item.id ? 'ad-nav-item--active' : ''}`}
              onClick={() => handleNavClick(item.id)}
            >
              <span className="ad-nav-icon"><Icon name={item.icon} size={18} /></span>
              <span className="ad-nav-text">{item.label}</span>
              {item.id === 'restaurants' && dashboardData?.unverifiedRestaurants > 0 && (
                <span className="ad-nav-badge">{dashboardData.unverifiedRestaurants}</span>
              )}
              {item.id === 'blogs' && dashboardData?.unapprovedBlogs > 0 && (
                <span className="ad-nav-badge">{dashboardData.unapprovedBlogs}</span>
              )}
            </button>
          ))}
        </nav>

        <div className="ad-sidebar-footer">
          <div className="ad-user-info">
            <div className="ad-user-avatar">{user?.email?.[0]?.toUpperCase() ?? 'A'}</div>
            <div className="ad-user-details">
              <span className="ad-user-email">{user?.email ?? 'admin'}</span>
              <span className="ad-user-role">Administrator</span>
            </div>
          </div>
          {onLogout && (
            <button className="ad-logout-btn" onClick={onLogout} title="Sign out">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                <polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
            </button>
          )}
        </div>
      </aside>

      {/* Sidebar overlay (mobile) */}
      {sidebarOpen && (
        <div className="ad-sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── Main ── */}
      <div className="ad-main">

        {/* Top bar */}
        <header className="ad-topbar">
          <button
            className="ad-menu-btn"
            onClick={() => setSidebarOpen(s => !s)}
            aria-label="Toggle menu"
          >
            <Icon name={sidebarOpen ? 'close' : 'menu'} size={20} />
          </button>

          <div className="ad-topbar-title">
            <span className="ad-topbar-icon"><Icon name={activeNav?.icon} size={16} /></span>
            {activeNav?.label}
          </div>

          <div className="ad-topbar-right">
            <div className="ad-topbar-dot" />
            <span className="ad-topbar-status">Live</span>
          </div>
        </header>

        {/* Content */}
        <main className="ad-content" key={activeSection}>
          {renderSection()}
        </main>
      </div>

      {/* ── Mobile bottom tab bar ── */}
      <nav className="ad-bottom-nav">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.id}
            className={`ad-bottom-nav-item ${activeSection === item.id ? 'ad-bottom-nav-item--active' : ''}`}
            onClick={() => handleNavClick(item.id)}
          >
            <span className="ad-bottom-nav-icon">
              <Icon name={item.icon} size={20} />
              {item.id === 'restaurants' && dashboardData?.unverifiedRestaurants > 0 && (
                <span className="ad-dot-badge" />
              )}
              {item.id === 'blogs' && dashboardData?.unapprovedBlogs > 0 && (
                <span className="ad-dot-badge" />
              )}
            </span>
            <span className="ad-bottom-nav-label">{item.label}</span>
          </button>
        ))}
      </nav>

    </div>
  );
};

export default AdminDashboard;